export namespace CookiebotSDK {
  const shownClassname = 'is-shown';
  let timeout;

  function handleOnShow() {
    const element = document.querySelector('#CookiebotWidget');
    if (!element) {
      timeout = setTimeout(() => {
        handleOnShow();
      }, 1000);
    } else {
      element?.classList?.add(shownClassname);
      clearTimeout(timeout);
    }
  }

  export function enableWidget() {
    handleOnShow();
    window.addEventListener('CookiebotOnLoad', handleOnShow, false);
  }

  export function disableWidget() {
    document
      .querySelector('#CookiebotWidget')
      ?.classList?.remove(shownClassname);
    document
      .querySelector('#CookiebotWidget')
      ?.classList?.remove('CookiebotWidget-open');
    window.removeEventListener('CookiebotOnLoad', handleOnShow, false);
    clearTimeout(timeout);
  }

  export function showSettings() {
    (
      document.querySelector(
        '#CookiebotWidget > button.CookiebotWidget-logo',
      ) as HTMLButtonElement
    )?.click();
  }
}
